
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.01 0a12 12 0 1012 12 12 12 0 00-12-12zm3.93 17.67H8.3v-1.3l3.79-4.14a9.42 9.42 0 001.16-1.53 2.48 2.48 0 00.35-1.23 1.87 1.87 0 00-.46-1.31 1.59 1.59 0 00-1.23-.5 1.82 1.82 0 00-1.43.56 2.21 2.21 0 00-.5 1.54h-1.9a3.7 3.7 0 01.47-1.87A3.25 3.25 0 019.9 6.6a4.3 4.3 0 012.03-.46 3.85 3.85 0 012.61.83 2.89 2.89 0 01.96 2.3 3.9 3.9 0 01-.48 1.79 10.2 10.2 0 01-1.58 2.12l-2.78 2.97h5.28z"}})])
          )
        }
      }
    